import React, { useContext } from 'react';
import { chain, size, sortBy } from 'underscore';
import PropTypes from 'prop-types';
import { Target as TargetInternal } from '@bingads-webui-react/dimensions-target';
import { withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

const Target = withControlErrorHandling(TargetInternal);

export const AgeRanges = {
  EighteenToTwentyFive: _TL_('18-24'),
  TwentyFiveToThirtyFive: _TL_('25-34'),
  ThirtyFiveToFifty: _TL_('35-49'),
  FiftyToSixtyFive: _TL_('50-64'),
  SixtyFiveAndAbove: _TL_('65+'),
  Unknown: _TL_('Unknown'),
};

export const AgeRangesCampaignToAdInsight = {
  EighteenToTwentyFive: 'EighteenToTwentyFour',
  TwentyFiveToThirtyFive: 'TwentyFiveToThirtyFour',
  ThirtyFiveToFifty: 'ThirtyFiveToFourtyNine',
  FiftyToSixtyFive: 'FiftyToSixtyFour',
  SixtyFiveAndAbove: 'SixtyFiveAndAbove',
  Unknown: _TL_('Unknown'),
};

const sortAgeRanges = ageRanges => sortBy(ageRanges, ageRange => AgeRanges[ageRange]);

export const formatAgeRange = (ageRange, i18n) => (AgeRanges[ageRange] ? i18n.getString(AgeRanges[ageRange]) : ageRange);

export const formatAgeRanges = (ageRanges, i18n) => {
  if (size(ageRanges) === size(AgeRanges)) {
    return i18n.getString(_TL_('Targeting: All ages'));
  }

  return chain(sortAgeRanges(ageRanges))
    .map(ageRange => formatAgeRange(ageRange, i18n))
    .join(i18n.getString(_TL_(', ')))
    .value();
};

export const AgeRange = ({ i18n, ageRanges }) => {
  const activity = useContext(ActivityContext);

  return (
    <Target
      i18n={i18n}
      description={i18n.getString(_TL_('Show your ads to people in these age ranges:'))}
      formatter={formatAgeRange}
      dimensions={ageRanges}
      availableDimensions={AgeRanges}
      validationProps={{ field: 'ageRanges' }}
      hideDeselectAll
      logger={{ log: activity.signal }}
    />
  );
};

AgeRange.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ageRanges: PropTypes.arrayOf(PropTypes.string).isRequired,
};
